module.exports = __webpack_public_path__ + "img/telegraph.43d46712.png";